var map = {
	"./cxm": 10774,
	"./cxm/": 10774,
	"./cxm/en/404": 44185,
	"./cxm/en/404.json": 44185,
	"./cxm/en/common": 27354,
	"./cxm/en/common.json": 27354,
	"./cxm/en/customers_list": 57429,
	"./cxm/en/customers_list.json": 57429,
	"./cxm/en/deals": 18210,
	"./cxm/en/deals.json": 18210,
	"./cxm/en/import_files": 49430,
	"./cxm/en/import_files.json": 49430,
	"./cxm/en/login": 45924,
	"./cxm/en/login.json": 45924,
	"./cxm/en/loyalty_b2b": 36346,
	"./cxm/en/loyalty_b2b.json": 36346,
	"./cxm/en/partners_list": 24373,
	"./cxm/en/partners_list.json": 24373,
	"./cxm/en/settings": 50686,
	"./cxm/en/settings.json": 50686,
	"./cxm/index": 10774,
	"./cxm/index.ts": 10774,
	"./init": 48897,
	"./init.ts": 48897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88469;